import { styled } from '../../../../providers/context/StyletronProvider/withStyletronProvider';

export const FormContainer = styled('div', ({ $isDesktop }: any) => ({
  ...($isDesktop ? { maxWidth: '672px' } : {}),
}));
